import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject, filter, firstValueFrom, Subject } from 'rxjs';
import { HubConnectionState } from '@microsoft/signalr';
import { FeedCommentModel, FeedModel } from '../../models/feed.model';

@Injectable({
    providedIn: 'root'
})
export class FeedSignalRService {
    private hubConnection!: signalR.HubConnection;

    //baseURl: string = 'https://localhost:7135/';//local
    baseURl: string = 'https://www.skeinforce.com:8080/';//production



    // Observables for live updates
    //public feedLiked$ = new BehaviorSubject<FeedModel>(null);
    public feedLiked$ = new Subject<FeedModel>();
    public newComment$ = new Subject<FeedCommentModel>();
    public commentLiked$ = new BehaviorSubject<any>(null);

    // Connection status observable
    public connectionStatus$ = new BehaviorSubject<boolean>(false);

    constructor() { }

    // Start connection
    public startConnection() {
        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(`${this.baseURl}feedHub`, { withCredentials: true })
            .withAutomaticReconnect()
            .build();

        this.hubConnection.start()
            .then(() => {
                console.log('SignalR Connected');
                this.connectionStatus$.next(true)
            })
            .catch(err => {
                console.error(err);
                this.connectionStatus$.next(false);
            });

        this.hubConnection.onclose(() => this.connectionStatus$.next(false));

        this.hubConnection.on('FeedLiked', (data) => this.feedLiked$.next(data));
        this.hubConnection.on('FeedComment', (data) => this.newComment$.next(data));
        this.hubConnection.on('CommentLiked', (data) => this.commentLiked$.next(data));
    }

    private async waitForConnection(): Promise<void> {
        if (this.hubConnection.state === HubConnectionState.Connected) return;
        await firstValueFrom(this.connectionStatus$.pipe(filter(status => status === true)));
    }

    public async joinFeedGroup(feedUid: string) {
        await this.waitForConnection();
        await this.hubConnection.invoke('JoinFeedGroup', `feed-${feedUid}`);
    }

    public async leaveFeedGroup(feedUid: string) {
        if (this.hubConnection?.state === HubConnectionState.Connected) {
            await this.hubConnection.invoke('LeaveFeedGroup', `feed-${feedUid}`);
        }
    }
}
